import React from 'react';

import Link from 'components/Link';

import moreButton from './assets/more-button.svg';
import './styles.css';

const MoreOptions = ({url, onClick, alt, openInNewTab = false}: any) => {
  const moreButtonImg = <img src={moreButton} alt={alt || 'More options'} />;
  const className = 'MoreOptions';

  if (url) {
    if (openInNewTab)
      return (
        <a
          className={className}
          href={url}
          target="_blank"
          rel="noopener noreferrer">
          {moreButtonImg}
        </a>
      );

    return (
      <Link className={className} to={url}>
        {moreButtonImg}
      </Link>
    );
  }

  return (
    <div className={className} onClick={onClick}>
      {moreButtonImg}
    </div>
  );
};

export default MoreOptions;
